import React from 'react';
import { Tabs, Badge } from 'antd';
import { MANTENCION_TABS } from './mantencionTabs';

// Barra de pestañas superior (desktop). Consume el mismo estado tab/onChange
// que el bottom-nav mobile; el badge rojo refleja los problemas del checklist.
function MantencionTopTabs({ tab, onChange, problems = 0 }) {
  const items = MANTENCION_TABS.map(({ k, label, Icon }) => ({
    key: k,
    label: (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <Icon />
        {k === 'checklist' ? (
          <Badge count={problems} size="small" offset={[8, -2]}>
            {label}
          </Badge>
        ) : (
          label
        )}
      </span>
    ),
  }));
  return <Tabs activeKey={tab} onChange={onChange} items={items} style={{ marginBottom: 4 }} />;
}

export default MantencionTopTabs;
